import React from 'react'
import LaundryManTable from 'components/Tables/LaundryMan/LaundryMan'

const ListLaundryMan = () => {
  return (
    <div><LaundryManTable /></div>
  )
}

export default ListLaundryMan